import { render, staticRenderFns } from "./ItemInventory.vue?vue&type=template&id=fad817d2&"
import script from "./ItemInventory.vue?vue&type=script&lang=ts&"
export * from "./ItemInventory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports